import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { SignInFormPresentation } from './sign-in-form.presentation';
import SignInFormVM from './sign-in-form.viewmodel';

export interface ISignInContainerProps {
    accountId: number;
    eventId: number;
    subdomain: string;
    requestAccessCodeRegistrationApprovalEnabled?: boolean;
}

const SignInFormContainer = withViewModel(SignInFormPresentation,
    async (props: ISignInContainerProps) => {
    const {
        accountId,
        eventId,
        subdomain,
        requestAccessCodeRegistrationApprovalEnabled = false,
    } = props;
    const signInVM = new SignInFormVM(
        accountId,
        eventId,
        subdomain,
        requestAccessCodeRegistrationApprovalEnabled
    );

        signInVM.initialize();

        return signInVM;
});

export { SignInFormContainer as SignInForm };